// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e2f60589","787":"27be9ffb","849":"41a2e744"}[chunkId] + ".chunk.js";
};